
































import Vue from "vue";

export default Vue.extend({
  name: "snackbar",
  props: {
    text: { type: String },
    color: { type: String },
    snackbar: { type: Boolean },
    responseButtons: { type: Boolean },
    message: { type: Object },
    centered: { type: Boolean }
  },
  methods: {
    approved(): void {
      this.$emit("approved", { approved: true, message: this.message });
    },
    denied(): void {
      this.$emit("approved", { approved: false, message: this.message });
    }
  }
});
